// 文档 URL 相关的展示工具（文档管理 / 分块管理共用）
const IMG_EXTS = ["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg"];
const PAGE_EXTS = ["html", "htm", "php", "jsp", "asp"];

// 数据类型按 URL 特征推导：图片扩展名→图片；无扩展名或页面后缀→网页链接；其余→文档
export const dataTypeOfUrl = (url) => {
  const name = String(url || "").toLowerCase().split("/").pop().split("?")[0];
  const ext = name.includes(".") ? name.split(".").pop() : "";
  if (IMG_EXTS.includes(ext)) return "image";
  if (!ext || PAGE_EXTS.includes(ext)) return "link";
  return "doc";
};

export const docFileName = (url) => {
  const clean = String(url || "").split("?")[0];
  const name = decodeURIComponent(clean.split("/").pop() || "");
  if (name) return name;
  // 无路径文件名（如 https://example.com/）时回退展示域名，避免显示"未知文件"
  const host = clean.match(/^https?:\/\/([^/]+)/);
  return host ? host[1] : "未知文件";
};
